





import React, {Component} from 'react';

import "./igv-page/home.css"

import { Container, Grid, Typography, TextField, FormControl, InputLabel, Select, MenuItem, Button, Box } from '@mui/material';


class Home extends Component{

    constructor(props){
        super(props);

        this.state={
            experimentID:undefined,
            chromosome:1,
            locus: undefined
        };


        this.handleChange_Experiment = this.handleChange_Experiment.bind(this);
        this.chromosomeHandle = this.chromosomeHandle.bind(this);
        this.locusHandle = this.locusHandle.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }


    handleSearch(evt){
        let {experimentID, locus, chromosome} = this.state;

        if(experimentID!== undefined && locus!== undefined && chromosome !== undefined){
            window.location.href = window.location.href + "browser/?file=" + experimentID + "&chrom=" + chromosome + "&locus=" + locus
        }
        else{
            alert("Please, provide the required information to go to the IGV Browser")
        }




    }

    handleChange_Experiment(evt){
        let fieldName = evt.target.name;
        let fleldVal = evt.target.value;

        this.setState({
            experimentID:fleldVal
        })
    }

    chromosomeHandle(evt){
        let fieldName = evt.target.name;
        let fleldVal = evt.target.value;

        this.setState({
            chromosome:fleldVal
        })
    }


    locusHandle(evt){
        let fieldName = evt.target.name;
        let fleldVal = evt.target.value;
        this.setState({
            locus:fleldVal
        })
    }

    
    render(){
        return (
            <Container className="main-content">
                <div className="welcome-message">
                    <Grid container spacing={3}>
                        <Grid item xs={3}/>
                        <Grid item xs={6}>
                            <div style={{marginTop:"1%", marginBottom: "3%"}}>
                                <Typography variant="h4">The IGV-Browser (igv.js) hosted by the Genome-Phenome Analysis Platform (GPAP) accesses alignments served
                                    by the <a href={"https://ega-archive.org/"}>European Genome-phenome Archive (EGA)</a> through its htsget server.
                                </Typography>
                                <Typography variant="h5">Please, select an Experiment ID and a genomic location to visualise it in the IGV Browser.</Typography>
                            </div>
                        </Grid>
                        <Grid item xs={3}/>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={3}/>
                        <Grid item xs={6}>
                            <div>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                       {/* <InputLabel htmlFor="experiment-id">Enter Experiment ID</InputLabel>*/}
                                        <TextField
                                            id="experiment-id"
                                            label={"Experiment ID"}
                                            placeholder="Experiment ID"
                                            onChange={this.handleChange_Experiment.bind(this)}
                                        />
                                </FormControl>
                                </Box>
                                <Box p={1}>
                                <FormControl fullWidth>
                                    <label htmlFor="select">Choose a Chromosome:</label>
                                    <Select
                                        label={"Chromosome"}
                                        id="chromosome"
                                        onChange={this.chromosomeHandle}
                                    >
                                        {Array.from({length: 22}, (_, i) => i + 1).map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
                                        <MenuItem value="X">X</MenuItem>
                                        <MenuItem value="Y">Y</MenuItem>
                                        <MenuItem value="M">M</MenuItem>
                                    </Select>

                                </FormControl>
                                </Box>
                                <Box p={1}>
                                    <FormControl fullWidth>

                                        <TextField
                                            id="locus"
                                            label={"Enter locus"}
                                            placeholder="E.g. 13656-13670"
                                            onChange={this.locusHandle}
                                        />
                                    </FormControl>
                                </Box>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    style={{marginTop: "1%"}}
                                    onClick={this.handleSearch}>
                                    Search & See
                                </Button>
                            </div>
                        </Grid>
                        <Grid item xs={3}/>
                    </Grid>
                </div>
            </Container>
        );
    }
}



export default Home;